import React from "react";
import { useNavigate } from "react-router-dom";
import "../SubscriptionButton/SubscriptionButton.css";

const SubscriptionButton = () => {
  const navigate = useNavigate();
  return (
    <button className="subscription-button" onClick={() => navigate("/all")}>
      My Subscription
    </button>
  );
};

export default SubscriptionButton;
